export default __webpack_public_path__ + "45034eb67a8a3758a675449831d9015f.png";